import { SET_SELECTED_SUBSIDIARIES } from '../actionTypes';

const selectedsubsidiaries = (state = null, action) => {
  switch (action.type) {
    case SET_SELECTED_SUBSIDIARIES:
      return action.subsidiaries;
    default:
      return state;
  }
};

export default selectedsubsidiaries;
